import React from 'react'
import PropTypes from 'prop-types'
import {Text, HStack} from '@salesforce/retail-react-app/app/components/shared/ui'

import Close from './close'

const Header = ({storeDetails, setStoreDetails}) => {
    return (
        <HStack gap="0" alignItems="start">
            {storeDetails.name && (
                <Text
                    as="h2"
                    fontFamily="heading"
                    fontSize="23px"
                    fontWeight="400"
                    lineHeight="normal"
                    letterSpacing="0.115px"
                    textTransform="capitalize"
                >
                    {storeDetails.name.toLowerCase()}
                </Text>
            )}

            <Close setStoreDetails={setStoreDetails} />
        </HStack>
    )
}

Header.propTypes = {
    storeDetails: PropTypes.shape({
        name: PropTypes.string
    }),
    setStoreDetails: PropTypes.func.isRequired
}

export default Header
